export default {"icons":{"iconfont":"mdi"},"theme":{"disable":true}}
